<template>
  <div>
    <div>
      <el-row>
        <!-- 工具条 -->
        <el-form
          :inline="true"
          :model="formInline"
          class="demo-form-inline toolbar"
          @submit.native.prevent
        >
          <el-form-item label="活动标题">
            <el-input
              clearable
              v-model.trim="formInline.title"
              placeholder="请输入活动标题"
              style="width: 200px;"
              @keyup.enter.native.prevent="enterSearch"
            ></el-input>
          </el-form-item>
          <el-form-item label="社区名称">
            <el-input
              clearable
              v-model.trim="formInline.communityName"
              placeholder="请输入社区名称"
              style="width: 180px;"
              @keyup.enter.native.prevent="enterSearch"
            ></el-input>
          </el-form-item>
          <el-form-item label="活动状态">
            <el-select
              v-model="formInline.status"
              style="width: 140px"
              clearable
            >
              <el-option value="" label="全部"></el-option>
              <el-option value="0" label="草稿"></el-option>
              <el-option value="1" label="待审核"></el-option>
              <el-option value="2" label="已通过"></el-option>
              <el-option value="3" label="已拒绝"></el-option>
              <el-option value="4" label="已结束"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="活动时间">
            <el-date-picker
              v-model="formInline.timeRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              style="width: 280px;"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="search"
              plain
              >查询</el-button
            >
            <el-button
              type="success"
              icon="el-icon-plus"
              @click="addActivity"
              plain
              >发布活动</el-button
            >
            <el-button
              type="info"
              @click="toStatistic"
              icon="el-icon-pie-chart"
              plain
              style="margin-left: 10px"
              >数据统计</el-button
            >
            <el-button
              type="info"
              @click="downReport"
              icon="el-icon-download"
              plain
              style="margin-left: 10px"
              >活动报表导出</el-button
            >
          </el-form-item>
        </el-form>

        <!-- 活动列表表格 -->
        <el-table
          style="width: 100%"
          :data="tableData"
          v-loading="tableLoading"
          ref="multipleTable"
          :header-cell-style="{
            'text-align': 'center',
            'font-size': '16px',
            'font-weight': '600',
            color: '#2d2d2d',
            'background-color': '#d4f5fa',
          }"
          :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
          :row-style="tableRowStyle"
        >
          <el-table-column
            prop="title"
            label="活动标题"
            min-width="200"
          ></el-table-column>
          <el-table-column
            prop="communityName"
            label="社区名称"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="address"
            label="活动地址"
            min-width="150"
          ></el-table-column>
          <el-table-column
            prop="startTime"
            label="开始时间"
            min-width="160"
          ></el-table-column>
          <el-table-column
            prop="endTime"
            label="结束时间"
            min-width="160"
          ></el-table-column>
          <el-table-column
            prop="capacity"
            label="活动容量"
            min-width="80"
          ></el-table-column>
          <el-table-column
            prop="enrolled"
            label="已报名"
            min-width="80"
          ></el-table-column>
          <el-table-column
            prop="attended"
            label="已参与"
            min-width="80"
          ></el-table-column>
          <el-table-column
            prop="status"
            label="活动状态"
            min-width="100"
            :formatter="formatStatus"
          ></el-table-column>
          <el-table-column
            prop="publisherName"
            label="发布人"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="createTime"
            label="发布时间"
            min-width="160"
          ></el-table-column>
          <el-table-column label="操作" min-width="280">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                plain
                @click="handleAudit(scope.row)"
                v-if="scope.row.status === 1"
                >审核</el-button>
              <el-button
                style="margin-left: 2px"
                type="success"
                size="mini"
                plain
                @click="handleSignUpList(scope.row)"
                v-if="scope.row.status === 2"
                >报名列表</el-button>
              <el-button
                style="margin-left: 2px"
                type="warning"
                size="mini"
                plain
                @click="handleEdit(scope.row)"
                v-if="scope.row.status === 0 || scope.row.status === 3"
                >编辑</el-button>
              <el-button
                style="margin-left: 2px"
                type="danger"
                size="mini"
                plain
                @click="handleDelete(scope.row)"
                v-if="scope.row.status === 0 || scope.row.status === 3"
                >删除</el-button>
              <el-button
                style="margin-left: 2px"
                type="info"
                size="mini"
                plain
                @click="handleDetail(scope.row)"
                >详情</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
          :page-size="pageSize"
          align="center"
          class="fenye"
        ></el-pagination>
      </el-row>

      <!-- 新增/编辑活动弹窗 -->
      <el-dialog
        :title="isEdit ? '编辑活动' : '发布活动'"
        width="70%"
        :visible.sync="formVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form ref="activityForm" :model="activityForm" :rules="formRules" label-width="120px">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="活动标题" prop="title">
                <el-input v-model="activityForm.title" placeholder="请输入活动标题"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="社区ID" prop="communityId">
                <el-input v-model="activityForm.communityId" placeholder="请输入社区ID" :disabled="isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="社区名称" prop="communityName">
                <el-input v-model="activityForm.communityName" placeholder="请输入社区名称" :disabled="isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="活动地址" prop="address">
                <el-input v-model="activityForm.address" placeholder="请输入活动地址"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开始时间" prop="startTime">
                <el-date-picker
                  v-model="activityForm.startTime"
                  type="datetime"
                  placeholder="选择开始时间"
                  value-format="yyyy-MM-dd HH:mm"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="结束时间" prop="endTime">
                <el-date-picker
                  v-model="activityForm.endTime"
                  type="datetime"
                  placeholder="选择结束时间"
                  value-format="yyyy-MM-dd HH:mm"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="活动容量" prop="capacity">
                <el-input v-model="activityForm.capacity" type="number" min="1" placeholder="请输入活动最大参与人数"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="isEdit">
              <el-form-item label="活动状态" prop="status">
                <el-select v-model="activityForm.status" placeholder="请选择活动状态">
                  <el-option value="0" label="草稿"></el-option>
                  <el-option value="1" label="待审核"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="活动内容" prop="content">
                <el-input v-model="activityForm.content" type="textarea" :rows="6" placeholder="请详细描述活动内容、流程、注意事项等"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="!isEdit">
              <el-form-item label="发布人ID" prop="publisherId">
                <el-input v-model="activityForm.publisherId" placeholder="请输入发布人ID" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="!isEdit">
              <el-form-item label="发布人姓名" prop="publisherName">
                <el-input v-model="activityForm.publisherName" placeholder="请输入发布人姓名" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="formVisible = false">取消</el-button>
          <el-button type="primary" @click="submitForm">确定</el-button>
        </div>
      </el-dialog>

      <!-- 审核弹窗 -->
      <el-dialog
        title="活动审核"
        width="40%"
        :visible.sync="auditVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form ref="auditForm" :model="auditForm" :rules="auditRules" label-width="100px">
          <el-form-item label="审核结果" prop="status">
            <el-select v-model="auditForm.status" placeholder="请选择审核结果">
              <el-option value="2" label="审核通过"></el-option>
              <el-option value="3" label="审核拒绝"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="审核意见" prop="auditRemark">
            <el-input v-model="auditForm.auditRemark" type="textarea" :rows="4" placeholder="请输入审核意见"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="auditVisible = false">取消</el-button>
          <el-button type="primary" @click="submitAudit">提交审核</el-button>
        </div>
      </el-dialog>

      <!-- 报名列表弹窗 -->
      <el-dialog
        title="活动报名列表"
        width="80%"
        :visible.sync="signUpVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form
          :inline="true"
          :model="signUpQuery"
          class="demo-form-inline"
          style="margin-bottom: 15px"
          @submit.native.prevent
        >
          <el-form-item label="用户姓名">
            <el-input
              clearable
              v-model.trim="signUpQuery.userName"
              placeholder="请输入用户姓名"
              style="width: 150px;"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系电话">
            <el-input
              clearable
              v-model.trim="signUpQuery.userPhone"
              placeholder="请输入联系电话"
              style="width: 150px;"
            ></el-input>
          </el-form-item>
          <el-form-item label="报名状态">
            <el-select
              v-model="signUpQuery.status"
              style="width: 120px"
              clearable
            >
              <el-option value="" label="全部"></el-option>
              <el-option value="0" label="已报名"></el-option>
              <el-option value="1" label="已签到"></el-option>
              <el-option value="2" label="已签退"></el-option>
              <el-option value="3" label="已取消"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="querySignUpList"
              plain
              >查询</el-button>
          </el-form-item>
        </el-form>
        <el-table
          style="width: 100%"
          :data="signUpTableData"
          v-loading="signUpLoading"
          :header-cell-style="{
            'text-align': 'center',
            'font-size': '15px',
            'font-weight': '600',
            'background-color': '#d4f5fa',
          }"
          :cell-style="{ 'text-align': 'center', 'font-size': '15px' }"
        >
          <el-table-column
            prop="userName"
            label="用户姓名"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="userPhone"
            label="联系电话"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="signUpTime"
            label="报名时间"
            min-width="160"
          ></el-table-column>
          <el-table-column
            prop="checkInTime"
            label="签到时间"
            min-width="160"
            :formatter="formatTimeNull"
          ></el-table-column>
          <el-table-column
            prop="checkOutTime"
            label="签退时间"
            min-width="160"
            :formatter="formatTimeNull"
          ></el-table-column>
          <el-table-column
            prop="status"
            label="报名状态"
            min-width="100"
            :formatter="formatSignUpStatus"
          ></el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
            min-width="150"
          ></el-table-column>
          <el-table-column label="操作" min-width="180">
            <template slot-scope="scope">
              <el-button
                type="success"
                size="mini"
                plain
                @click="handleCheckIn(scope.row)"
                v-if="scope.row.status === 0"
                >签到</el-button>
              <el-button
                style="margin-left: 2px"
                type="warning"
                size="mini"
                plain
                @click="handleCheckOut(scope.row)"
                v-if="scope.row.status === 1"
                >签退</el-button>
              <el-button
                style="margin-left: 2px"
                type="danger"
                size="mini"
                plain
                @click="handleCancelSignUp(scope.row)"
                v-if="scope.row.status === 0"
                >取消报名</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @size-change="handleSignUpSizeChange"
          @current-change="handleSignUpCurrentChange"
          :current-page="signUpCurrentPage"
          layout="total, prev, pager, next"
          :total="signUpTotal"
          :page-size="signUpPageSize"
          align="center"
          class="fenye"
          style="padding: 15px 0"
        ></el-pagination>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="signUpVisible = false">关闭</el-button>
        </div>
      </el-dialog>

      <!-- 数据统计弹窗 -->
      <el-dialog
        title="活动数据统计"
        width="60%"
        :visible.sync="statisticVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form
          :inline="true"
          :model="statisticQuery"
          class="demo-form-inline"
          style="margin-bottom: 20px"
          @submit.native.prevent
        >
          <el-form-item label="统计时间">
            <el-date-picker
              v-model="statisticQuery.timeRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              style="width: 280px;"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="queryStatisticData"
              plain
              >查询统计</el-button>
          </el-form-item>
        </el-form>
        <el-row :gutter="30" style="margin-bottom: 20px">
          <el-col :span="4">
            <div class="statistic-card">
              <div class="statistic-title">总活动数</div>
              <div class="statistic-value">{{ statisticData.total || 0 }}</div>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="statistic-card">
              <div class="statistic-title">待审核</div>
              <div class="statistic-value">{{ statisticData.pendingAudit || 0 }}</div>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="statistic-card">
              <div class="statistic-title">已通过</div>
              <div class="statistic-value">{{ statisticData.approved || 0 }}</div>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="statistic-card">
              <div class="statistic-title">已拒绝</div>
              <div class="statistic-value">{{ statisticData.rejected || 0 }}</div>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="statistic-card">
              <div class="statistic-title">已结束</div>
              <div class="statistic-value">{{ statisticData.finished || 0 }}</div>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="statistic-card">
              <div class="statistic-title">总参与人数</div>
              <div class="statistic-value">{{ statisticData.totalAttended || 0 }}</div>
            </div>
          </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="statisticVisible = false">关闭</el-button>
        </div>
      </el-dialog>

      <!-- 报表导出字段选择弹窗 -->
      <el-dialog
        title="导出字段选择"
        width="420px"
        :visible.sync="fieldsVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="closeFieldsDialog"
      >
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="handleCheckAllChange"
          >全选</el-checkbox
        >
        <div style="margin: 15px 0"></div>
        <el-checkbox-group
          v-model="selectedFields"
          @change="handleCheckedFieldsChange"
          style="display: flex; flex-wrap: wrap; width: 100%"
        >
          <el-checkbox
            v-for="item in exportFields"
            :label="item.value"
            :key="item.value"
            size="medium"
            :disabled="item.required"
            style="width: 42%"
            >{{ item.label }}</el-checkbox
          >
        </el-checkbox-group>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="fieldsVisible = false">取消</el-button>
          <el-button type="primary" @click="confirmExport">确认导出</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import bus from "@/vuex/eventBus";
import { baseURL } from "@/utils/request.js";

export default {
  name: "CommunityActivityList",
  data() {
    return {
      // 查询表单
      formInline: {
        title: "",
        communityName: "",
        status: "",
        timeRange: [] // 活动时间范围
      },
      // 表格数据
      tableData: [],
      tableLoading: false,
      // 分页参数
      currentPage: 1,
      pageNo: 1,
      pageSize: 10,
      totalDataNumber: 0,

      // 弹窗控制
      formVisible: false, // 新增/编辑弹窗
      auditVisible: false, // 审核弹窗
      signUpVisible: false, // 报名列表弹窗
      statisticVisible: false, // 数据统计弹窗
      fieldsVisible: false, // 导出字段选择弹窗

      // 表单数据
      isEdit: false,
      activityForm: {
        id: null,
        title: "",
        content: "",
        address: "",
        startTime: "",
        endTime: "",
        capacity: 0,
        communityId: "",
        communityName: "",
        status: 0,
        publisherId: "",
        publisherName: ""
      },
      auditForm: {
        id: null,
        status: null,
        auditRemark: "",
        auditorId: "",
        auditorName: ""
      },
      // 报名列表查询参数
      signUpQuery: {
        activityId: "",
        userName: "",
        userPhone: "",
        status: ""
      },
      signUpTableData: [],
      signUpLoading: false,
      signUpCurrentPage: 1,
      signUpPageNo: 1,
      signUpPageSize: 10,
      signUpTotal: 0,
      // 统计查询参数
      statisticQuery: {
        timeRange: [],
        communityId: ""
      },
      statisticData: {},

      // 表单验证规则
      formRules: {
        title: [
          { required: true, message: "请输入活动标题", trigger: "blur" }
        ],
        communityId: [
          { required: true, message: "请输入社区ID", trigger: "blur" }
        ],
        communityName: [
          { required: true, message: "请输入社区名称", trigger: "blur" }
        ],
        address: [
          { required: true, message: "请输入活动地址", trigger: "blur" }
        ],
        startTime: [
          { required: true, message: "请选择开始时间", trigger: "change" }
        ],
        endTime: [
          { required: true, message: "请选择结束时间", trigger: "change" }
        ],
        capacity: [
          { required: true, message: "请输入活动容量", trigger: "blur" },
        ],
        content: [
          { required: true, message: "请输入活动内容", trigger: "blur" }
        ]
      },
      auditRules: {
        status: [
          { required: true, message: "请选择审核结果", trigger: "change" }
        ],
        auditRemark: [
          { required: true, message: "请输入审核意见", trigger: "blur" }
        ]
      },

      // 导出字段配置
      exportFields: [
        { value: "title", label: "活动标题", required: true },
        { value: "communityName", label: "社区名称", required: true },
        { value: "address", label: "活动地址", required: true },
        { value: "startTime", label: "开始时间", required: true },
        { value: "endTime", label: "结束时间", required: true },
        { value: "capacity", label: "活动容量" },
        { value: "enrolled", label: "已报名人数" },
        { value: "attended", label: "已参与人数" },
        { value: "status", label: "活动状态" },
        { value: "publisherName", label: "发布人" },
        { value: "createTime", label: "发布时间" }
      ],
      selectedFields: ["title", "communityName", "address", "startTime", "endTime"],
      checkAll: false,
      isIndeterminate: true
    };
  },

  methods: {
    // 表格行样式
    tableRowStyle({ row, rowIndex }) {
      return rowIndex % 2 === 0 
        ? { "background-color": "#ffffff" } 
        : { "background-color": "#e4f5f8" };
    },

    // 格式化活动状态
    formatStatus(row) {
      const statusMap = { 
        0: "草稿", 
        1: "待审核", 
        2: "已通过", 
        3: "已拒绝", 
        4: "已结束" 
      };
      return statusMap[row.status] || "未知";
    },

    // 格式化报名状态
    formatSignUpStatus(row) {
      const statusMap = { 
        0: "已报名", 
        1: "已签到", 
        2: "已签退", 
        3: "已取消" 
      };
      return statusMap[row.status] || "未知";
    },

    // 格式化空时间
    formatTimeNull(row, column) {
      return row[column.prop] || "-";
    },

    // 搜索
    search() {
      this.pageNo = 1;
      this.queryActivityList();
    },

    // 回车搜索
    enterSearch() {
      this.search();
    },

    // 分页大小变更
    handleSizeChange(val) {
      this.pageSize = val;
      this.queryActivityList();
    },

    // 当前页变更
    handleCurrentChange(val) {
      this.pageNo = val;
      this.queryActivityList();
    },

    // 查询活动列表
    queryActivityList() {
      this.tableLoading = true;
      const params = {
        ...this.formInline,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        startTime: this.formInline.timeRange[0] || "",
        endTime: this.formInline.timeRange[1] || "",
      };

      this.$postJson("omc/activity/list", params).then(res => {
        this.tableLoading = false;
        if (res.code === 200) {
          this.tableData = res.result.list || [];
          this.totalDataNumber = Number(res.result.total) || 0;
          this.currentPage = res.result.pageNum || 1;
        } else {
          this.$message.error(res.message || "查询失败");
          this.tableData = [];
          this.totalDataNumber = 0;
        }
      }).catch(() => {
        this.tableLoading = false;
        this.tableData = [];
        this.totalDataNumber = 0;
      });
    },

    // 新增活动
    addActivity() {
      this.isEdit = false;
      this.activityForm = {
        id: null,
        title: "",
        content: "",
        address: "",
        startTime: "",
        endTime: "",
        capacity: 0,
        status: 1, // 默认为待审核状态
      };
      this.formVisible = true;
    },

    // 编辑活动
    handleEdit(row) {
      this.isEdit = true;
      this.activityForm = { ...row };
      // 时间格式转换
      this.activityForm.startTime = this.formatDate(row.startTime);
      this.activityForm.endTime = this.formatDate(row.endTime);
      this.formVisible = true;
    },

    // 日期格式化（适配后端返回格式）
    formatDate(dateStr) {
      if (!dateStr) return "";
      // 处理后端返回的时间格式（如：2024-05-20T14:30:00 转 2024-05-20 14:30）
      return dateStr.replace("T", " ").substring(0, 16);
    },

    // 提交表单（新增/编辑）
    submitForm() {
      this.$refs.activityForm.validate(valid => {
        if (valid) {
          // 校验开始时间不能晚于结束时间
          if (new Date(this.activityForm.startTime) > new Date(this.activityForm.endTime)) {
            this.$message.error("开始时间不能晚于结束时间");
            return;
          }

          const url = this.isEdit 
            ? "omc/activity/update" 
            : "omc/activity/publish";
          
          this.$postJson(url, this.activityForm).then(res => {
            if (res.code === 200) {
              this.$message.success(this.isEdit ? "编辑成功" : "发布成功");
              this.formVisible = false;
              this.queryActivityList();
            } else {
              this.$message.error(res.message || "操作失败");
            }
          });
        }
      });
    },

    // 删除活动
    handleDelete(row) {
      this.$confirm("确定要删除该活动吗？", "提示", {
        type: "warning"
      }).then(() => {
        this.$postJson("omc/activity/delete", { id: row.id }).then(res => {
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.queryActivityList();
          } else {
            this.$message.error(res.message || "删除失败");
          }
        });
      }).catch(() => {
        this.$message.info("已取消删除");
      });
    },

    // 审核活动
    handleAudit(row) {
      this.auditForm = {
        id: row.id,
        status: null,
        auditRemark: "",
      };
      this.auditVisible = true;
    },

    // 提交审核
    submitAudit() {
      this.$refs.auditForm.validate(valid => {
        if (valid) {
          this.$postJson("omc/activity/audit", this.auditForm).then(res => {
            if (res.code === 200) {
              this.$message.success("审核成功");
              this.auditVisible = false;
              this.queryActivityList();
            } else {
              this.$message.error(res.message || "审核失败");
            }
          });
        }
      });
    },

    // 查看报名列表
    handleSignUpList(row) {
      this.signUpQuery.activityId = row.id;
      this.signUpPageNo = 1;
      this.signUpVisible = true;
      this.querySignUpList();
    },

    // 查询报名列表
    querySignUpList() {
      this.signUpLoading = true;
      const params = {
        ...this.signUpQuery,
        pageNo: this.signUpPageNo,
        pageSize: this.signUpPageSize
      };

      this.$postJson("omc/activity/signUpRecords", params).then(res => {
        this.signUpLoading = false;
        if (res.code === 200) {
          this.signUpTableData = res.result.list || [];
          this.signUpTotal = Number(res.result.total) || 0;
          this.signUpCurrentPage = res.result.pageNum || 1;
        } else {
          this.$message.error(res.message || "查询失败");
          this.signUpTableData = [];
          this.signUpTotal = 0;
        }
      }).catch(() => {
        this.signUpLoading = false;
        this.signUpTableData = [];
        this.signUpTotal = 0;
      });
    },

    // 报名列表分页大小变更
    handleSignUpSizeChange(val) {
      this.signUpPageSize = val;
      this.querySignUpList();
    },

    // 报名列表当前页变更
    handleSignUpCurrentChange(val) {
      this.signUpPageNo = val;
      this.querySignUpList();
    },

    // 签到操作
    handleCheckIn(row) {
      this.$confirm(`确定要为【${row.userName}】执行签到操作吗？`, "提示", {
        type: "info"
      }).then(() => {
        this.$postJson("omc/activity/checkIn", {
          activityId: row.activityId,
          userId: row.userId,
          remark: `签到操作：${new Date().toLocaleString()}`
        }).then(res => {
          if (res.code === 200) {
            this.$message.success("签到成功");
            this.querySignUpList();
          } else {
            this.$message.error(res.message || "签到失败");
          }
        });
      }).catch(() => {
        this.$message.info("已取消签到");
      });
    },

    // 签退操作
    handleCheckOut(row) {
      this.$confirm(`确定要为【${row.userName}】执行签退操作吗？`, "提示", {
        type: "info"
      }).then(() => {
        this.$postJson("omc/activity/checkOut", {
          activityId: row.activityId,
          userId: row.userId,
          remark: `签退操作：${new Date().toLocaleString()}`
        }).then(res => {
          if (res.code === 200) {
            this.$message.success("签退成功");
            this.querySignUpList();
          } else {
            this.$message.error(res.message || "签退失败");
          }
        });
      }).catch(() => {
        this.$message.info("已取消签退");
      });
    },

    // 取消报名
    handleCancelSignUp(row) {
      this.$confirm(`确定要取消【${row.userName}】的报名吗？`, "提示", {
        type: "warning"
      }).then(() => {
        this.$postJson("omc/activity/cancelSignUp", {
          activityId: row.activityId,
          userId: row.userId
        }).then(res => {
          if (res.code === 200) {
            this.$message.success("取消报名成功");
            this.querySignUpList();
          } else {
            this.$message.error(res.message || "取消失败");
          }
        });
      }).catch(() => {
        this.$message.info("已取消操作");
      });
    },

    // 打开数据统计
    toStatistic() {
      this.statisticQuery.communityId = sessionStorage.getItem("communityId") || "";
      this.statisticVisible = true;
      this.queryStatisticData();
    },

    // 查询统计数据
    queryStatisticData() {
      const params = {
        ...this.statisticQuery,
        startTime: this.statisticQuery.timeRange[0] || "",
        endTime: this.statisticQuery.timeRange[1] || ""
      };

      this.$postJson("omc/activity/statistic", params).then(res => {
        if (res.code === 200) {
          this.statisticData = res.result || {};
        } else {
          this.$message.error(res.message || "统计失败");
          this.statisticData = {};
        }
      }).catch(() => {
        this.statisticData = {};
      });
    },

    // 报表导出
    downReport() {
      this.fieldsVisible = true;
    },

    // 全选处理
    handleCheckAllChange(val) {
      this.selectedFields = val 
        ? this.exportFields.map(item => item.value) 
        : this.exportFields.filter(item => item.required).map(item => item.value);
      this.isIndeterminate = false;
    },

    // 字段选择变化
    handleCheckedFieldsChange(value) {
      const requiredLength = this.exportFields.filter(item => item.required).length;
      this.checkAll = value.length === this.exportFields.length;
      this.isIndeterminate = value.length > requiredLength && value.length < this.exportFields.length;
    },

    // 关闭字段选择弹窗
    closeFieldsDialog() {
      const requiredFields = this.exportFields.filter(item => item.required).map(item => item.value);
      this.selectedFields = [...new Set([...requiredFields, ...this.selectedFields])];
    },

    // 确认导出
    confirmExport() {
      const params = new URLSearchParams();
      params.append("fields", this.selectedFields.join(","));
      params.append("title", this.formInline.title || "");
      params.append("status", this.formInline.status || "");
      params.append("startTime", this.formInline.timeRange[0] || "");
      params.append("endTime", this.formInline.timeRange[1] || "");

      window.location.href = `${baseURL}omc/activity/export?${params.toString()}`;
      this.fieldsVisible = false;
    }
  },

  mounted() {
    this.queryActivityList();
    // 监听详情页返回刷新
    this.$bus.$on("refreshActivityList", () => {
      this.queryActivityList();
    });
  },

  beforeDestroy() {
    this.$bus.$off("refreshActivityList");
  }
};
</script>

<style lang="scss" scoped>
.toolbar {
  padding: 10px 0 10px 10px;
  background: #fff;
  border-radius: 4px 4px 0 0;
}

.fenye {
  padding: 20px 0;
  background: #fff;
  border-radius: 0 0 4px 4px;
}

::v-deep .el-dialog__header {
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
}

::v-deep .el-dialog__footer {
  padding: 15px 20px;
  border-top: 1px solid #eee;
}

::v-deep .el-form-item {
  margin-bottom: 15px;
}

.statistic-card {
  background: #f5f7fa;
  border-radius: 6px;
  padding: 15px;
  text-align: center;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.statistic-title {
  font-size: 16px;
  color: #666;
  margin-bottom: 8px;
}

.statistic-value {
  font-size: 24px;
  font-weight: bold;
  color: #1890ff;
}
</style>